import { Card, CardContent } from "@/components/ui/card";
import { Users, ShieldCheck, GraduationCap, UserCheck, Baby } from "lucide-react";

interface UserStatsCardsProps {
  total: number;
  admins: number;
  teachers: number;
  parents: number;
  superAdmins: number;
}

const UserStatsCards = ({ total, admins, teachers, parents, superAdmins }: UserStatsCardsProps) => {
  const stats = [
    { label: "إجمالي المستخدمين", value: total, icon: Users, color: "text-primary" },
    { label: "مدراء حضانات", value: admins, icon: ShieldCheck, color: "text-blue-500" },
    { label: "معلمون", value: teachers, icon: GraduationCap, color: "text-green-500" },
    { label: "أولياء أمور", value: parents, icon: Baby, color: "text-purple-500" },
    { label: "مشرفون عامّون", value: superAdmins, icon: UserCheck, color: "text-amber-500" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {stats.map((s) => (
        <Card key={s.label}>
          <CardContent className="p-4 flex items-center gap-3">
            <div className={`p-2 rounded-lg bg-muted ${s.color}`}>
              <s.icon className="w-5 h-5" />
            </div>
            <div>
              <p className="text-2xl font-bold">{s.value}</p>
              <p className="text-xs text-muted-foreground">{s.label}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default UserStatsCards;
